/**
 * Filter Types for JotAudit
 * 
 * Centralized type definitions for tab-specific filters.
 * Each tab can define its own filter shape.
 */

import type { RuleScope, RuleType } from '@features/rules/types';

/**
 * Rules Tab Filters
 */
export interface RulesFilters {
  scope: RuleScope;
  ruleType: RuleType | 'all';
  showDisabled: boolean;
}

export const DEFAULT_RULES_FILTERS: RulesFilters = {
  scope: 'both',
  ruleType: 'compliance',
  showDisabled: false,
};

/**
 * Providers Tab Filters (placeholder for future)
 */
export interface ProvidersFilters {
  // Add provider-specific filters here
}

export const DEFAULT_PROVIDERS_FILTERS: ProvidersFilters = {};

/**
 * Notes Tab Filters (placeholder for future)
 */
export interface NotesFilters {
  // Add note-specific filters here
}

export const DEFAULT_NOTES_FILTERS: NotesFilters = {};

/**
 * Union type for all filter types
 */
export type TabFilters = RulesFilters | ProvidersFilters | NotesFilters;

/**
 * Filter configuration by tab
 */
export type FiltersByTab = {
  rules: RulesFilters;
  providers: ProvidersFilters;
  notes: NotesFilters;
  claims: Record<string, never>; // Empty for now
};

